import store from '@/store'
import { ref } from '@vue/composition-api'

export const configTableUsuarios = () => {
  const tableColumns = [
    { key: 'nombreCompleto', label: 'Nombre', sortable: true },
    { key: 'materias', label: 'Materias', sortable: false },
    { key: 'automatico', label: 'Reinscribir', sortable: true },
  ]
  return { tableColumns }
}
export const fetchUsuariosReinscripcion = data => {
  const configRequest = ref({
    wsType: 'wsalumno', //* WebService name
    wsParams: { action: 15, token: store.state.cuenta.session.token, data: { id_periodo: data.id_periodo, id_plan: data.id_plan } }, //* Request params
    filterGetter: 'reinscripcion/filterUsuariosReinscripcion', //* Getter function to filter data
  })
  return { configRequest }
}
export const useUsuariosCatalogos = () => {
  const agendaOptions = [
    { label: 'Si', value: 2 },
    { label: 'No', value: 1 },
  ]
  const ordenOptions = [
    { label: 'Si', value: 2 },
    { label: 'No', value: 1 },
  ]

  return {
    agendaOptions, ordenOptions,
  }
}
export const variablesFiltro = () => {
  const varFilters = ref({
    aceptaseguir: null, cumple: null, agenda: null, orden: null, tipoAlumno: null, nivel: null,
  })
  return { varFilters }
}
